



















require('axios')
import { Component, Prop, Vue } from 'vue-property-decorator';

import { BCarousel, BCarouselSlide } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

@Component(
  {
    components:{
      BCarousel,
      BCarouselSlide,
    }
  }
)
export default class Home extends Vue {
  
  mounted(){
  }


}
